import httpStatus from 'http-status';

export default {
  getStatus(code) {
    return httpStatus[code] || null;
  },
};

export function getStatus(code) {
  return httpStatus[code] || null;
}
